exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dashboard {\n  width: 100%;\n  overflow: hidden;\n  background: whitesmoke;\n}\n\n.dashboard /deep/ .widget {\n  background-color: darkgrey;\n}\n\n.widget .close {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n}\n\n.handle {\n  cursor: move;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 292
// module chunks = 0